import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const waLink = 'https://wa.me/1234567890?text=Hola,%20quiero%20acceder%20al%20bundle%20de%20recetas%20sin%20gluten%20por%20$2.97';
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-145">
      
    </div>;
}